export default "__VITE_ASSET__DgRLRpeF__"